// extracted by mini-css-extract-plugin
export default {"imgWallpaper":"WallpaperMenu_imgWallpaper__IxN7P"};